module.exports = __webpack_public_path__ + "static/media/pl3.65597688.png";